import { handleActions } from 'redux-actions';

import type {
  CardType,
  Meta,
  TestResult,
} from 'components/settings/components/sections/cards/cards.types';

import { actions } from '../../actions/customCards';

export const {
  getCustomCardById,
  getCustomCardByIdSucceeded,
  getCustomCardByIdFailed,

  testCustomCard,
  testCustomCardSucceeded,
  testCustomCardFailed,

  resetCustomCard,
} = actions;

export interface CustomCardState {
  card_type?: CardType;
  hook: {
    title: string;
    hook_id: string;
    headers: Record<string, string> | null;
    uri_template: string;
    created_at?: string;
    card_version: string;
  };
  template: string;
}

export interface CustomCardsState {
  cards: CustomCardState[];
  currentCard: CustomCardState;
  testResult: TestResult | null;
  meta: Meta | null;
}

export function emptyCard(): CustomCardState {
  return {
    card_type: 'custom',
    hook: {
      title: '',
      hook_id: '',
      headers: null,
      uri_template: '',
    },
    template: '',
  } as CustomCardState;
}

const initialState: CustomCardsState = {
  cards: [],
  currentCard: emptyCard(),
  testResult: null,
  meta: null,
};

// Reducer
export const customCards = handleActions<CustomCardsState, any>(
  {
    [getCustomCardById.toString()]: (state: CustomCardsState, action: any) => {
      return {
        ...state,
        meta: {
          ...state.meta,
          getCardByIdAsyncStatus: 'loading',
        },
      };
    },

    [getCustomCardByIdSucceeded.toString()]: (
      state: CustomCardsState,
      action: any,
    ) => {
      return {
        ...state,
        currentCard: action.payload.data,
        meta: {
          ...state.meta,
          getCardByIdAsyncStatus: 'succeeded',
        },
      };
    },

    [getCustomCardByIdFailed.toString()]: (state: CustomCardsState) => {
      return {
        ...state,
        meta: {
          ...state.meta,
          getCardByIdAsyncStatus: 'failed',
        },
      };
    },

    [testCustomCard.toString()]: (state: CustomCardsState) => {
      return {
        ...state,
        meta: { ...state.meta, testAsyncStatus: 'loading' },
        testResult: null,
      };
    },

    [testCustomCardSucceeded.toString()]: (
      state: CustomCardsState,
      action: any,
    ) => {
      return {
        ...state,
        meta: { ...state.meta, testAsyncStatus: 'succeeded' },
        testResult: Object.assign({}, action.payload.data),
      };
    },

    [testCustomCardFailed.toString()]: (state: CustomCardsState) => {
      return {
        ...state,
        meta: {
          ...state.meta,
          testAsyncStatus: 'failed',
        },
      };
    },

    [resetCustomCard.toString()]: (state: CustomCardsState) => {
      return {
        ...state,
        currentCard: emptyCard(),
        testResult: null,
        meta: {
          ...state.meta,
          getCardByIdAsyncStatus: null,
        },
      };
    },
  },
  initialState,
);
